import {FC, useEffect, useState} from 'react'
import Content from "../main/Content";
import {storeBooking} from "../../lib/booking";
import {getHjulskifte} from "../../wordpress/operations/get-hjulskifte";
import Message from "./Message";
import HjulskifteBooking from "./HjulskifteBooking";
import Offers from "../Campaign";
import HjulskifteTireOffer from "./HjulskifteTireOffer";
import TireShopOpen from "../common/TireShop/TireShopOpen";

interface Props {
    booking: Booking
    pageContent:ContentPage,
    setBooking: Function
}

const Hjulskifte: FC<Props> = ({ pageContent, booking, setBooking }) => {
    const [hjulskifte, setHjulskifte] = useState<any>(null);

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    if(!hjulskifte) {
        getHjulskifte(booking.hjulskifte_key).then((val) => {
            setHjulskifte(val)
            booking.car = val.car
            booking.booking_flow = val.service.booking_flow

            let addService = true
            for(let i=0; i<booking.serviceArray.length; i++){
                if(booking.serviceArray[i].slug === val.service.slug)
                    addService = false
            }
            if(addService)
                booking.serviceArray.push(val.service)

            booking.service = val.service
            booking.workshop =  booking.contact.workshop = parseInt(val.spot.workshop)
            booking.date = val.spot.date
            booking.hjulskifte.date = val.spot.date
            booking.hjulskifte.spot_id = val.customer.data.timeSpot
            booking.submission.time = val.spot.time
            booking.submission.slug = 'vanta-pa-plats'
            booking.submission.type = ['time']
            booking.submission.name = 'Vänta på plats'

            // Customer data
            booking.contact.firstname = val.customer.data.firstName
            booking.contact.lastname = val.customer.data.lastName
            booking.contact.mail = val.customer.data.email
            booking.contact.phone = val.customer.data.phone ? val.customer.data.phone : val.customer.data.phoneMobil
            booking.hjulskifte.mail_customer_id = val.customer.data.customerId
            booking.tires.dimension = val.customer.data.tireDimension
            storeBooking(booking, setBooking)
        })
        return;
    }

    let contentToRender;
    switch (hjulskifte.status) {
        case '404':
            contentToRender = <Message title={'Reservationen hittades ej'} content={''} />
            break;
        case 'closed':
            contentToRender =
                <>
                    <HjulskifteTireOffer booking={booking} setBooking={setBooking} data={hjulskifte}/>
                    <TireShopOpen booking={booking} setBooking={setBooking}/>
                    <HjulskifteBooking booking={booking} setBooking={setBooking} data={hjulskifte} />
                </>
            break;
        case 'closed_old':
            contentToRender =
                <>
                    <h2>Tiden för reservation har gått ut</h2>
                    <p>Tidsgränsen för länken har passerat. Du kan boka en egen tid i vårt bokningssystem. Din kundinformation kommer vara förifylld.</p>
                    <p>Klicka på Nästa steg nedan för att välja tid</p>
                </>
            break;
        case 'booked':
            contentToRender = <Message title={'Reservation finns redan.'} content={''} />
            break;
        case 'open':
            contentToRender =
                <>
                    <HjulskifteTireOffer booking={booking} setBooking={setBooking} data={hjulskifte}/>
                    <TireShopOpen booking={booking} setBooking={setBooking}/>
                    <HjulskifteBooking booking={booking} setBooking={setBooking} data={hjulskifte} />
                </>
            break;
    }
    /*
    Views
    1. Reservation
    2. Reservartion löpt ut
    3. Resrvation bekräftad
    3. Reservation borttagen
     */
    return (
        <>
            <div className="input-outer reg-container woocommerce">
                <div className="row mobile-reverse">
                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 col-xxs-12">
                        <div className="text-content">
                            <Offers booking={booking} setBooking={setBooking}/>
                        </div>
                    </div>
                    <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12 col-xxs-12">
                        <Content booking={booking} content={pageContent} />
                        {contentToRender}
                    </div>
                </div>
            </div>
        </>
    )
};

export default Hjulskifte
